import { ButtonV2 } from "../../../../Atoms/ButtonV2";
import { cn } from "../../../../../utils/cn";
import {
  ACTIVE_TENANT,
  TENANT_BG_LIGHT_CLASSES,
  TENANT_TEXT_CLASSES,
} from "../../../../../constants/tenant_colors";

interface INewSchedulingCardProps {
  className?: string;
  onAccess: () => void;
}

export const NewSchedulingCard = ({
  className,
  onAccess,
}: INewSchedulingCardProps) => {
  return (
    <div
      className={cn(
        TENANT_BG_LIGHT_CLASSES[ACTIVE_TENANT],
        "rounded-[10px] w-full p-8",
        className,
      )}
    >
      <img
        src="/assets/svgs/icon-add.svg"
        alt="icone calendario"
        className="mb-20"
      />

      <div className={cn("mb-5", TENANT_TEXT_CLASSES[ACTIVE_TENANT])}>
        <h3 className="text-2xl font-extrabold mb-2">Novo agendamento</h3>
        <p className="text-sm">
          Agende a sua vistoria. Transferência, primeiro emplacamento ou
          primeiro registro. Pagamento online, sem fila.
        </p>
      </div>

      <ButtonV2 onClick={onAccess}>
        Acessar
        <img
          alt="seta para a direira"
          src="/assets/svgs/icon-arrow-forward.svg"
        />
      </ButtonV2>
    </div>
  );
};
